import dayjs from "dayjs";
import { LOCATION_HISTORY_PATH_TYPES } from "../constants";
import { useNavigationHistoryPath } from "../store";
import { DriverStop, DriverStopPeriod } from "../types";
import { useMemo } from "react";

const MINUTES_15 = 15;
const HOURS_8 = 480;

export const useCalculateDriverStopDetails = () => {
  const path = useNavigationHistoryPath();

  return useMemo(
    () =>
      (path ?? []).reduce((driverStopMap, item) => {
        if (LOCATION_HISTORY_PATH_TYPES.parking !== item.type) {
          return driverStopMap;
        }

        const [from, to] = item.locations;

        const startTime = dayjs(from?.timestampUtc);
        const finishTime = dayjs(to?.timestampUtc);
        const durationTime = dayjs.duration(finishTime.diff(startTime));

        let mapKey: DriverStopPeriod | null = null;

        if (durationTime.as("minutes") < MINUTES_15) {
          mapKey = DriverStopPeriod.less15min;
        }
        if (
          durationTime.as("minutes") > MINUTES_15 &&
          durationTime.as("minutes") < HOURS_8
        ) {
          mapKey = DriverStopPeriod.more15min;
        }

        if (durationTime.as("minutes") > HOURS_8) {
          mapKey = DriverStopPeriod.more8hours;
        }

        if (mapKey === null) {
          return driverStopMap;
        }

        const detail = driverStopMap.get(mapKey);

        if (!detail) {
          driverStopMap.set(mapKey, {
            count: 1,
            time: durationTime.asMinutes(),
          });
        } else {
          driverStopMap.set(mapKey, {
            count: detail.count + 1,
            time: detail.time + durationTime.asMinutes(),
          });
        }

        return driverStopMap;
      }, new Map<DriverStopPeriod, DriverStop>()),
    [path]
  );
};
